/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";

import { FieldPropTypes } from "../lib/types";
import { StyledHelperText, StyledLabel, StyledTextarea } from "../lib/styles";

const Description = ({
  disabled,
  handleFieldChange,
  value,
}: FieldPropTypes): React.ReactElement => {
  return (
    <>
      <StyledLabel htmlFor="description">Description</StyledLabel>
      <StyledTextarea
        data-testid="description-textarea"
        disabled={disabled}
        id="description"
        name="description"
        onChange={(event): void => {
          handleFieldChange({ description: event.target.value });
        }}
        type="text"
        value={value}
      />
      <StyledHelperText>
        Enter Brand Description from the Tango spreadsheet in English - see
        Translations below to add a second language. Visible to end users in the
        rewards catalog.
      </StyledHelperText>
    </>
  );
};

export default Description;
